module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "dg-btn-loader"
  }, [_c('span', {
    staticClass: "dg-circles"
  }, [_c('span', {
    staticClass: "dg-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "dg-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "dg-circle"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0a4b5bf7!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugin/components/btn-loader.vue
// module id = 63
// module chunks = 0